<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <!-- basica -->
        <mat-card class="mat-elevation-z8 w-100" *ngIf="isBasica">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Responsável pela Conferência
                                </mat-label>
                                <input matInput id="txtResponsavelConferencia" #txtResponsavelConferencia maxlength="40"
                                    formControlName="responsavel_pela_conferencia_lote">
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtResponsavelConferencia.value.length}} / 40</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.responsavel_pela_conferencia_lote)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Conferência Física
                                </mat-label>
                                <input matInput id="txtDataConferenciaFisica" #txtDataInicio maxlength="10"
                                    mask="d0/M0/0000" formControlName="data_conferencia_fisica"
                                    (input)="validateDate($event)" [dropSpecialCharacters]="false">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-error
                                    *ngIf="formulario.controls.data_conferencia_fisica.hasError('dateHighThanActual')">A
                                    data não pode ser menor que a Data de Ensaque</mat-error>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_conferencia_fisica)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data de Apontamento
                                </mat-label>
                                <input matInput id="txtDataApontamento" #txtDataInicio maxlength="10" mask="d0/M0/0000"
                                    formControlName="data_hora_apontamento" (input)="validateDate($event)"
                                    [dropSpecialCharacters]="false">
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-error
                                    *ngIf="formulario.controls.data_hora_apontamento.hasError('dateHighThanActual')">A
                                    data não pode ser menor que a Data de Ensaque</mat-error>
                                <mat-error>{{hasErrorFormControl(formulario.controls.data_hora_apontamento)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Status de Processo</mat-label>
                                <mat-select formControlName="status_processo" disableOptionCentering>
                                    <mat-option *ngFor="let item of listStatus" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Criado por</mat-label>
                                <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="80"
                                    formControlName="criado_por" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCriadoPor.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Observação</mat-label>
                                <textarea matInput id="txtObs" #txtObs maxlength="255"
                                    formControlName="observacao"></textarea>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.observacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>